import $api from "..";
import { AxiosResponse } from "axios";
import { IIParametrsFilter } from "../common/api_interfaces/filter/IIParametrsFilter";
import { IFilterOptions } from "../common/api_interfaces/filter/IFilterOptions";

export default class FilterService {
    async getFilters(
        body: IIParametrsFilter
    ): Promise<AxiosResponse<IFilterOptions>> {
        return $api.post<IFilterOptions>(`/getFilters`, body);
    }
}
